/**
 * NOTES
 * - po nacteni stranky necht jsou ajax-id unikatni. Duplicitu at zpusobi jedine skript.
 * - slovo "referer" v kontextu HTTP je takto - s jednim r - napsano spravne :)
 *
 * TODO
 * - zdokumentovat (hlavne parametry send, AJAX.send a handleResponse)
 * - neni lepsi mit jako location default ajax-href? - NE, casto nechceme nastavovat
 *
 */

import $ from "jquery";
import {addClass, removeClass} from "./utils"
import {VisibleCenterer} from "./visible-centering";
import {
  find,
  matches,
  memoizeSimple as memoize,
  assign,
  pick,
  keys,
  some,
  isString,
  hasOwn,
  nextTick
} from "./framework/voidash";
import {$win} from "./_globals.js";

//=============================================================================
function findMatch(arr, pattern) {
  return find(arr, item => matches(item, pattern));
}

//=============================================================================

function pickProps(obj, keys) {
  if (!keys) return assign({}, obj);
  return pick(obj, keys);
}

//=============================================================================

//=============================================================================
// UTILS
//=============================================================================
const formDataSupported = false; // TODO implement on server ... typeof FormData === "function";

//=============================================================================
function canSubmitForm(el) {
  return el.getAttribute("type") === "submit" || el.tagName === "BUTTON" && !el.hasAttribute("type");
}

//=============================================================================
function serializeForm(form, btn) {
  const params = {};

  for (let i = 0; i < form.elements.length; i++) {
    const el = form.elements[i];
    if (el.name && !el.disabled) {
      if (canSubmitForm(el)) {
        // if(!btn) btn = el; // if submit button wasn't given, take the first one
        continue;
      }
      if (el.type === "checkbox") {
        if (el.checked) {
          if (el.name.slice(-2) === "[]" && params[el.name]) {
            // kvuli notifikacim na AV chceme posilat jen posledni hodnotu a konkatenujeme kdyz tam je [] kvuli proarms
            if (typeof params[el.name] === "string") params[el.name] = [params[el.name], el.value];
            else params[el.name] = [...params[el.name], el.value];
          } else {
            params[el.name] = el.value;
          }
        }
      } else if (el.type === "radio") {
        if (el.checked) {
          params[el.name] = el.value;
        }
      } else {
        params[el.name] = el.value;
      }
    }
  }

  if (btn && btn.name) params[btn.name] = btn.value;

  return queryStringStringify(params).slice(1);
}

//=============================================================================

function loadingDelay(onEnter, onLeave, always) {
  const enterTimeout = 200;
  const leaveTimeout = 200;

  let enteredAt;

  let timeout = setTimeout(() => {
    onEnter();
    enteredAt = Date.now();
    timeout = null;
  }, enterTimeout);

  function leave(...args) {
    const duration = Date.now() - enteredAt;

    if (timeout) {
      clearTimeout(timeout);
      always(...args)
    } else if (duration > leaveTimeout) {
      always(...args);
      onLeave();
    } else {
      setTimeout(() => {
        always(...args);
        onLeave();
      }, leaveTimeout - duration);
    }
  }

  return leave;
}

//=============================================================================
function decodeURIComponentWithSpaces(str) {
  return decodeURIComponent(str).replace(/\+/g, " ");
}

//=============================================================================
function queryStringParse(qs) {
  const out = {};
  if (!qs.length) return out;
  if (qs[0] === "?") qs = qs.substring(1);
  const parts = qs.split("&");
  for (const part of parts) {
    if (!part) continue;
    const keyval = part.split("=");
    if (keyval.length === 1) {
      out[decodeURIComponentWithSpaces(keyval[0])] = true;
    } else {
      out[decodeURIComponentWithSpaces(keyval[0])] = decodeURIComponentWithSpaces(keyval[1]);
    }
  }
  return out;
}

//=============================================================================
function queryStringStringify(obj) {
  let out = "?";
  const props = keys(obj);

  if (!some(props, key => obj[key] !== null)) return "";

  let sep = "";

  function append(key, val) {
    if (val == null) return;

    if (val === true) out += sep + encodeURIComponent(key);
    else out += sep + encodeURIComponent(key) + "=" + encodeURIComponent(val);

    sep = "&";
  }

  for (const key of props) {
    const val = obj[key];

    if (isString(val)) {
      append(key, val);
    } else if (val) {
      val.forEach(val => append(key, val));
    }
  }

  return out;
}

//=============================================================================
function paramsFromURL(url) {
  const a = document.createElement("a");
  a.href = url;
  return queryStringParse(a.search)
}

//=============================================================================
function paramsToURL(url, params) {
  if (!url) return null;
  if (!params) return url;
  const a = document.createElement("a");
  a.href = url;
  const search = queryStringStringify(params);
  a.search = search === "?" ? "" : search;
  return a.href;
}

//=============================================================================
// CONTEXTS
//=============================================================================

const contexts = {
  global: {
    location: window.location.href,
    changedParams: paramsFromURL(window.location.href)
  }
};

function ensureContext(el) {
  let context = el.getAttribute("data-context");
  if(!contexts.hasOwnProperty(context)) {
    const location = el.getAttribute("data-context-location");
    contexts[context] = {
      location: location,
      changedParams: paramsFromURL(location)
    };
  }
}

function getContext(el, inclusive) {
  if(!inclusive) el = el.parentNode;
  while(el && el.nodeType === Node.ELEMENT_NODE) {
    if(el.hasAttribute("data-context")) {
      ensureContext(el);
      return el.getAttribute("data-context");
    }
    el = el.parentNode;
  }
  return "global";
}

//=============================================================================
// XHR
//=============================================================================
function makeURL(ref, scope, context) {
  const separator = ref.indexOf("?") === -1 ? "?" : "&";

  let contextPart = "";
  if(!context) context = "global";
  if(context !== "global") contextPart = "&ajaxContext=" + context;

  return ref + separator
    + 'ajax=' + scope
    + contextPart
    + '&ajaxReferer=' + encodeURIComponent(contexts[context].location)
    + "&ajaxRand=" + Math.random().toFixed(5).substring(2);
}

//=============================================================================
const classStacks = [];
let setBodyClass = false;

const spinnerCenterer = new VisibleCenterer({
  centered: ".spinner-border:not(.js-no-centering)",
  wrapper: ".loader-content, .loader-content-alt"
});

function addScopeClass(name, scope, context) {
  if (setBodyClass) addClass(document.body, name + "-" + ((scope === "*") ? "all" : scope));
  const els = getRelevantElements(document.body, scope, context);
  for (const item of els) addClass(item, name);
}

function removeScopeClass(name, scope, context) {
  if (setBodyClass)  removeClass(document.body, name + "-" + ((scope === "*") ? "all" : scope));
  const els = getRelevantElements(document.body, scope, context);
  for (const item of els) removeClass(item, name);
}

function pushClassStack(name, scopes, context) {
  if (setBodyClass) addClass(document.body, name);
  for (const scope of scopes) {
    let record = findMatch(classStacks, {name, scope, context});
    if (!record) classStacks.push(record = { name, scope, context, cnt: 0 });
    addScopeClass(name, scope, context);
    record.cnt++;
  }
}

function popClassStack(name, scopes, context) {
  let allEmpty = true;
  for (const scope of scopes) {
    let record = findMatch(classStacks, {name, scope, context});
    if (!record) continue;
    record.cnt--;
    if (record.cnt) allEmpty = false;
    else removeScopeClass(name, scope, context)
  }
  if (setBodyClass && allEmpty) removeClass(document.body, name);
}

/* Bere za parametr objekt s vlastnostmi:
   - *url (ke kteremu sam prida nase ajax parametry)
   - *scope (viz vyse)
   - *data (string, object, FormData nebo HTMLFormElement)
   - callback
   - errorCallback
   - progressCallback
   - httpMethod (ignoruje se, pokud data jsou FormData nebo (jsou HTMLFormElement AND FormDataSupported): vzdy POST)
   - invisible (nezobrazuje se kolecko ani loadingClass)

   Vraci objekt s vlastnostmi:
   - abort
 */
const activeRequests = {};
let doNotHideSpinner = false;

const sendDefaults = {
  // TODO: co pridat url: "url://?&" (nejak translated)
  callback: null,
  errorCallback: null,
  progressCallback: null,
  httpMethod: "GET",
  invisible: false
};

function send(opts) {
  let xhr = null;

  opts = Object.assign({}, sendDefaults, opts);

  let data = opts.data;
  let aborted = false;

  const ret = {
    abort: function () {
      if (xhr) xhr.abort();
      aborted = true;
    }
  };

  if (data instanceof HTMLFormElement) // data can be a form element, in which case we use the best supported method for sending
  {
    if (formDataSupported) {
      data = new FormData(data);
    } else {
      data = serializeForm(data);
    }
  }

  // track request
  const dataStr = typeof data === "string" ? data : String(Math.random()); // assume non-string data always differ
  const token = `${opts.url}~~~~~${opts.context}~~~~~${opts.scope}~~~~~${dataStr}`;
  // var now = Date.now();
  if (hasOwn(activeRequests, token)/* && activeRequests[token].issued > now - 1e3*/) {
    console.warn("AJAX: preventing duplicate request");
    return ret;
  }
  activeRequests[token] = {
    // issued: now
  };

  const isFormData = data && formDataSupported && (data instanceof FormData);

  xhr = new XMLHttpRequest();
  const scopes = opts.scope.split(/\s+/);
  const callbacks = [];
  const callbacks_pre = [];

  // callbacks_req defined further down
  callbacks_req.forEach(cb => {
    cb(Object.assign({}, opts, {
      addCallback(cb, pos) {
        (pos === "pre" ? callbacks_pre : callbacks).push(cb);
      }
    }));
  });

  if (!opts.invisible) pushClassStack("loading", scopes, opts.context);

  const onComplete = loadingDelay(
    function onEnter() {
      if (!opts.invisible) {
        pushClassStack("spinning", scopes, opts.context);
        spinnerCenterer.update();
      }
    },
    function onLeave() {
      if (!opts.invisible && !doNotHideSpinner) popClassStack("spinning", scopes, opts.context);
    },
    function always(status, responseText) {
      if (status === 200) {
        if (!aborted) {
          callbacks_pre.forEach(function (cb) {
            cb();
          });
          if (typeof opts.callback === "function") opts.callback(responseText);
          callbacks.forEach(function (cb) {
            cb();
          });
        }
      } else {
        if (typeof opts.errorCallback === "function") opts.errorCallback(status);
      }
      if (!opts.invisible) popClassStack("loading", scopes, opts.context);

      delete activeRequests[token];
    }
  );

  xhr.onreadystatechange = function () {
    if (this.readyState === 4) onComplete(this.status, this.responseText);
  };

  xhr.open(isFormData ? "POST" : opts.httpMethod, makeURL(opts.url, opts.scope, opts.context), true); // force POST if data is FormData

  if (isFormData) {
    xhr.setRequestHeader("Content-type", "multipart/form-data");
    xhr.upload.onprogress = opts.progressCallback;
  } else {
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  }

  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);

  return ret;
}

//=============================================================================
function mergeParams(params, overriddenNames, context) {
  if (!overriddenNames) return params;
  const changedParams = contexts[context].changedParams;
  const out = assign({}, params, changedParams); // overridden with params, that changed so far
  if (overriddenNames) {
    for (const key of overriddenNames) out[key] = hasOwn(params, key) ? params[key] : null;
  }
  return out;
}

//=============================================================================
function setLocation(location, method, context) {
  if (!method) method = "replace";
  if (!context) context = "global";

  contexts[context].location = location;
  const methodName = method + "State";
  if (context === "global" && typeof history[methodName] === "function") {
    history[methodName](Object.assign({}, contexts[context].changedParams), document.title, location);
  }
}

//=============================================================================
function urlEqualExceptHash(url1, url2) {
  const a1 = document.createElement("a");
  a1.href = url1;

  const a2 = document.createElement("a");
  a2.href = url2;

  return a1.protocol === a2.protocol && a1.host === a2.host && a1.pathname === a2.pathname && a1.search === a2.search;
}

window.addEventListener("popstate", function (evt) {
  const url = location.href;
  if (urlEqualExceptHash(url, contexts.global.location)) return; // tohle je tu proto, ze nejakej starej samsung pali popstate po nacteni,
                                                                 // a taky proto, ze pri zmene pouze hashe to reloadnout nepotrebujeme

  AJAX.send({
    url: url,
    method: "replace",
    scope: "*",
    callback: function () {
      contexts.global.location = url;
      contexts.global.changedParams = evt.state;
    }
  });
});
//=============================================================================
// DOM
//=============================================================================
const getAttrPropRegex = memoize(function (propName) {
  return new RegExp(`(?:^|,\\s*)${propName}:(.+?)(?:\\s*,\\s*\\w+:|$)`);
  // poznamka k posledni casti regularu: konec stringu nebo carka nasledovana dalsi deklaraci, tj. \s*\w+:
});

function attrProp(el, propName) {
  if (!el.hasAttribute("data-ajax")) return null;
  const str = el.getAttribute("data-ajax");
  const matches = getAttrPropRegex(propName).exec(str);
  return matches && matches[1];
}

//=============================================================================
function href(el) {
  return (window.SVGAnimatedString && (el.href instanceof SVGAnimatedString)) ? el.href.baseVal : el.href;
}

//=============================================================================
function prop(el, propName) {
  if (!el) return null;

  const attrName = "data-ajax-" + propName;
  if (el.hasAttribute(attrName)) return el.getAttribute(attrName);

  const fromAttr = attrProp(el, propName);
  if (fromAttr) return fromAttr;

  if (propName === "id") return el.id; // zkusime ztotoznit na zaklade id, kdyz nevyslo data-ajax-id
  if (propName === "href") return href(el); // href se nemusi psat explicitne, je-li shodny s atributem href
  if (propName === "target") return prop(el, "scope"); // target se nemusi psat explicitne, je-li shodny se scope
  return null;
}

//=============================================================================
function locationPropHref(el) {
  if(el.tagName === "A") return href(el);
  return prop(el, "href");
}

function locationProp(el) {
  if (!el) return null;
  const location = prop(el, "location");
  return location === "href" && locationPropHref(el) || el[location] || location || null; // for data-ajax-location="attrName" (e.g. href)
}

//=============================================================================
function getElementByAjaxId(id, context) {
  if (!id) return null;
  const list = document.querySelectorAll("[data-ajax], [id]");
  for (let i = 0; i < list.length; i++) {
    const el = list[i];
    if (prop(el, "id") === id && getContext(el) === context) return el;
  }
  return null;
}

//=============================================================================
// manually clone scripts, so they run after insertion into DOM
function makeScriptsWork(el) {
  const scripts = Array.prototype.slice.call(el.querySelectorAll("script[data-ajax-run]"));
  for (const script of scripts) {
    const replacement = document.createElement("script");
    replacement.innerHTML = script.innerHTML;
    for (let j = 0; j < script.attributes.length; j++) {
      const attr = script.attributes[j];
      replacement.setAttribute(attr.name, attr.value);
    }
    script.parentNode.insertBefore(replacement, script);
    script.parentNode.removeChild(script);
  }
}

//=============================================================================
function getDOMTree(html) {
  const dummyDiv = document.createElement("div");
  dummyDiv.isDummy = true;
  dummyDiv.innerHTML = html;
  makeScriptsWork(dummyDiv);
  return dummyDiv;
}

//=============================================================================
const getScopeRegex = memoize(function (target) {
  target = target.replace(/\s+/g, "|");
  return new RegExp(`(?:^|\\s)(?:${target}|\\*)(?:$|\\s)`); // list of scopes or *
});

function getRelevantElements(domTree, target, context) {
  const parentSelector = !context || context === "global" ? "" : `[data-context='${context}']`;
  const candidates = domTree.querySelectorAll(`${parentSelector} [data-ajax-scope], ${parentSelector} [data-ajax]`);
  const match = target === "*" ? null : getScopeRegex(target);
  const res = [];
  for (let i = 0; i < candidates.length; i++) {
    const scope = prop(candidates[i], "scope");
    if (!scope) continue;
    if (match === null || match.test(scope)) res.push(candidates[i]);
  }
  return res;
}


//=============================================================================
function getOffsetTop(el) {
  let off = 0;
  do {
    if (!isNaN(el.offsetTop)) {
      off += el.offsetTop;
    }
  } while ((el = el.offsetParent));
  return off;
}

//=============================================================================
function scrollUpTo(anchor) {
  const top = getOffsetTop(anchor);
  if (window.scrollY > top) window.scrollTo(0, top);
}
//=============================================================================
const appendRefs = {};

const makeAppendRefID = (context, id) => `${context}$myCrazyDelimiter$${id}`;

function getAppendRef(id, context) {
  const refID = makeAppendRefID(context, id);
  let ref = appendRefs[refID];
  if (ref && !closestAll(ref, node => (node === document))) {
    delete appendRefs[refID];
    ref = null;
  } // no longer in document - remove. Possibly misplacing the ref element after the first relevant element instead of the last one.
  if (ref) return ref;
  const el = getElementByAjaxId(id, context);
  if (!el) return null;
  appendRefs[refID] = ref = document.createComment("AJAX APPEND REFERENCE ID=" + refID);
  el.parentNode.insertBefore(ref, el.nextSibling);
  return ref;
}

function deleteAppendRef(id, context) {
  const refID = makeAppendRefID(context, id);
  const ref = appendRefs[refID];
  if (ref && ref.parentNode) ref.parentNode.removeChild(ref);
  delete appendRefs[refID];
}

//=============================================================================
function parseJSONElement(el) {
  const jsonString = el.innerHTML;
  let ret = undefined;
  try {
    ret = JSON.parse(jsonString);
  } catch (e) {
    console.error(e);
  }
  return ret;
}
//=============================================================================
function doComplexElementAction(el, domInstance, act, context) {
  let match; // declared like this so that potential future actions can follow the same scheme match = ...; if (match) ...

  match = /^insertAfter\((.+)\)$/i.exec(act);
  if(match) {
    const target = document.querySelector(match[1]);
    if(!target) return;
    target.insertAdjacentElement("afterend", el);
    if(domInstance) domInstance.parentNode.removeChild(domInstance);
    deleteAppendRef(prop(el, "id"), context);
  }
}
//=============================================================================
function doElementAction(el, method, context) {
  if (!isDetachedDOM(el)) return; // already inserted
  const domInstance = getElementByAjaxId(prop(el, "id"), context);
  const act = prop(el, "action") || method;
  let ref;

  const ifNotAppend = prop(el, "if_not_append");
  if (ifNotAppend && (method === "append" || method === "append-content" || method === "prepend-content")) return;

  const anchor = $(prop(el, "anchor")).get(0);

  switch (act) {
    case 'append':
      ref = getAppendRef(prop(el, "id"), context);
      if (ref) ref.parentNode.insertBefore(el, ref);
      break;
    case 'append-content':
      if(domInstance) {
        while (el.childNodes.length) domInstance.appendChild(el.firstChild);
      }
      break;
    case 'prepend-content':
      if(domInstance) {
        while (el.childNodes.length) domInstance.insertBefore(el.lastChild, domInstance.firstChild);
      }
      break;
    case 'replace':
      if(domInstance) {
        if (anchor) scrollUpTo(anchor);

        ref = getAppendRef(prop(el, "id"), context);

        if (ref) {
          domInstance.parentNode.removeChild(domInstance);
          ref.parentNode.insertBefore(el, ref);
        }
      }
      break;
    case 'replace-content':
      if(domInstance) {
        if (anchor) scrollUpTo(anchor);

        while (domInstance.childNodes.length) domInstance.removeChild(domInstance.firstChild);
        while (el.childNodes.length) domInstance.appendChild(el.firstChild);
      }
      break;
    case 'delete':
      if(domInstance) {
        ref = getAppendRef(prop(el, "id"), context); // create reference + find out if element exists
        if (ref) {
          domInstance.parentNode.removeChild(domInstance);
        }
      }
      break;
    case 'delete-content':
      console.error(`AJAX: action '${act}' for elements not implemented`);
      // TODO
      break;

    default:
      doComplexElementAction(el, domInstance, act, context);
      break;
  }
}

//=============================================================================
function isDetachedDOM(el) {
  return closest(el, function (el) { return el.isDummy; });
}

//=============================================================================
function doPortionAction(begin, end, method, context) {
  if (!isDetachedDOM(begin)) return; // already inserted
  const act = prop(begin, "action") || method;
  const domBegin = getElementByAjaxId(prop(begin, "id"), context);
  const domEnd = getElementByAjaxId(prop(end, "id"), context);
  let el;

  const anchor = document.getElementById("list_top") || document.getElementById("list_top_" + prop(begin, "scope"));

  switch (act) {
    case 'replace-content': // the same in this context
    case 'replace':
      if (anchor) scrollUpTo(anchor);
      for (el = domBegin.nextSibling; el && el !== domEnd; el = domBegin.nextSibling) domBegin.parentNode.removeChild(el); // clear
      for (el = begin.nextSibling; el && el !== end; el = begin.nextSibling) domEnd.parentNode.insertBefore(el, domEnd);   // append
      domBegin.parentNode.replaceChild(begin, domBegin);                                                                   // replace delimiters
      domEnd.parentNode.replaceChild(end, domEnd);
      break;
    case 'append-content':
    case 'append':
      for (el = begin.nextSibling; el && el !== end; el = begin.nextSibling) domEnd.parentNode.insertBefore(el, domEnd);
      break;
    case 'prepend-content':
      for (el = end.previousSibling; el && el !== begin; el = end.previousSibling) domBegin.parentNode.insertBefore(el, domBegin.nextSibling);
      break;
    case 'delete-content':
    case 'delete':
      console.error(`AJAX: action '${act}' for portions not implemented`);
      // TODO
      break;
  }
}

//=============================================================================
const callbacks_res = [];
const callbacks_req = [];
const callbacks_id = {};

function invokeIdCallbacks(id, props, res) {
  const callbacks = callbacks_id[id];
  if(!callbacks) return;
  for (const callback of callbacks) callback(props, res);
}

const REDIRECTED = {}; // unique symbol

function handleResponse(props, response) {
  try {
    return JSON.parse(response);
  } catch (e) {
  }

  const domTree = getDOMTree(response);

  if (window.AJAXTreeCallback) window.AJAXTreeCallback(domTree);

  const context = props.context || "global";
  const relevantElements = getRelevantElements(domTree, props.scope, context);

  const titleEls = domTree.getElementsByTagName("title");
  if (titleEls && titleEls.length) document.title = titleEls[0].textContent;

  const portionBegin = [];  // TODO: nested portions aren't supported - inner gets replaced before outer, which deletes inner portions content
  const returns = {};
  let aborted = false;

  for (let i = 0; i < relevantElements.length; i++) {
    const el = relevantElements[i];
    let ret, fce, scope;
    switch (prop(el, "role")) {
      case 'a':
      case 'form':
      case 'element':
        if(!aborted) {
          doElementAction(el, props.method, context);
        }
        break;
      case 'json':
        ret = parseJSONElement(el);
        if (ret !== undefined) {
          returns[prop(el, "id")] = ret;
        }
        fce = prop(el, "callback");
        if (fce && typeof window[fce] === "function") window[fce](ret);
        break;
      case 'location':
        if(getContext(el) === "global") AJAX.setLocation(el.textContent || el.innerText, "replace");
        break;
      case 'redirect':
        window.location.href = el.textContent || el.innerText;
        doNotHideSpinner = true;
        return REDIRECTED;
      case 'ajax-redirect':
        scope = prop(el, "scope");
        /*var scopes = scope.split(/\s+/);
        var wasSpinning = hasClass(document.body, "spinning");
        if (wasSpinning) {
          pushClassStack("spinning", scopes, context);
        }*/
        AJAX.send(
          {
            scope,
            method: "replace",
            url: el.textContent || el.innerText,
            location: el.textContent || el.innerText/*,
            callback: function () {
              if (wasSpinning) popClassStack("spinning", scopes, context);
            }*/
          });
        break;
      case 'begin':
        portionBegin.push(el);
        break;
      case 'end':
        if (portionBegin.length && !aborted) doPortionAction(portionBegin.pop(), el, props.method, context); // TODO: should we check for equal scope on begin and end?
        break;
      case 'abort':
        aborted = true;
        returns.__aborted = true;
        break;
    }
  }

  // next tick so click/submit handlers complete
  // TODO: call in handleClick/handleSubmit/AJAX.send in the same tick
  nextTick(function() {
    for (const callback of callbacks_res) callback(props, returns);
  });

  return returns;
}

//=============================================================================
// EVENTS
//=============================================================================
function getElementCallback(origin) {
  for (let i = 0; i < arguments.length; i++) {
    const fnName = prop(arguments[i], "callback");
    if (fnName && typeof window[fnName] === "function") {
      return window[fnName];
    }
  }

  return null;
}

//=============================================================================
function getOverriddenParams (el) {
  const attr_name = "data-overridden-params";
  if (el.hasAttribute(attr_name)) {
    return el.getAttribute(attr_name).split(/\s*,\s*/).filter(Boolean);
  }

  return null;
}

//=============================================================================
function getRetainedParams (el) {
  const attr_name = "data-retain-params";
  if (el.hasAttribute(attr_name)) {
    return el.getAttribute(attr_name).split(/\s*,\s*/).filter(Boolean);
  }

  return null;
}

//=============================================================================
function handleClick(btn) {
  const id = prop(btn, "id");
  let href = prop(btn, "href");
  let location = locationProp(btn);
  const method = prop(btn, "method") || "replace"; // our ajax method, NOT xhr method
  const history = method.substring(0, 7) === "replace" ? "push" : "replace"; // heuristics
  const scope = prop(btn, "target");
  const elementCallback = getElementCallback(btn);
  const context = getContext(btn);

  let hrefParams = null;
  let locationParams = null;

  const overriddenParams = getOverriddenParams(btn); // TODO: zohlednovat jenom pokud bereme href z atributu a ne z data-ajax[-href]
  if(overriddenParams) {
    hrefParams = mergeParams(paramsFromURL(href), overriddenParams, context);
    locationParams = mergeParams(paramsFromURL(location), overriddenParams, context);
  }

  const retainedParams = getRetainedParams(btn); // TODO: zohlednovat jenom pokud bereme href z atributu a ne z data-ajax[-href]
  if (retainedParams) {
    hrefParams = pickProps(mergeParams(paramsFromURL(href), [], context), retainedParams);
    locationParams = pickProps(mergeParams(paramsFromURL(location), [], context), retainedParams);
  }

  href = paramsToURL(href, hrefParams);
  location = paramsToURL(location, locationParams);

  function onSuccess(response) {
    const props = {method, scope, context, __origin: btn};
    const ret = handleResponse(props, response);
    if(ret === REDIRECTED) return;
    if (elementCallback) elementCallback(ret, btn);
    invokeIdCallbacks(id, props, ret);
    if (location) setLocation(location, history, context);
    contexts[context].changedParams = locationParams;
  }

  send({
    url: href,
    scope: scope,
    callback: onSuccess,
    context: context,
    __origin: btn // metadata for use in onRequest
  });
}

//=============================================================================
function handleSubmit(form, btn) {
  const id = prop(form, "id");
  let href = prop(btn, "href") || prop(form, "href") || form.getAttribute("action") || window.location.href;
  const method = prop(btn, "method") || prop(form, "method") || "replace"; // our ajax method, NOT xhr method
  const history = method.substr(0, 7) === "replace" ? "push" : "replace"; // heuristics
  const scope = prop(btn, "target") || prop(form, "target");
  let location = locationProp(btn) || locationProp(form);
  const elementCallback = getElementCallback(btn, form);
  const context = getContext(form);

  let hrefParams = null;
  let locationParams = null;

  const overriddenParams = getOverriddenParams(form);
  if (overriddenParams) {
    hrefParams = mergeParams(paramsFromURL(href), overriddenParams, context);
    locationParams = mergeParams(paramsFromURL(location), overriddenParams, context);
  }

  const retainedParams = getRetainedParams(form);
  if (retainedParams) {
    hrefParams = pickProps(mergeParams(paramsFromURL(href), [], context), retainedParams);
    locationParams = pickProps(mergeParams(paramsFromURL(location), [], context), retainedParams);
  }

  href = paramsToURL(href, hrefParams);
  location = paramsToURL(location, locationParams);

  function onSuccess(response) {
    if(prop(form, "action") !== "noop") form.reset();
    const props = {method, scope, context, __origin: btn};
    const ret = handleResponse(props, response);
    if(ret === REDIRECTED) return;
    if (elementCallback) elementCallback(ret, form, btn);
    invokeIdCallbacks(id, props, ret);
    if(ret.__aborted) return;
    if (location) setLocation(location, history, context);
    contexts[context].changedParams = locationParams;
  }

  let data = serializeForm(form, btn);
  const httpMethod = form.method;

  if (httpMethod.toUpperCase() === "GET") {
    href = paramsToURL(href, Object.assign(paramsFromURL(href), queryStringParse(data)));
    data = "";
    if (!location) {
      // TODO: check na vitr
      location = href;
      locationParams = mergeParams(paramsFromURL(location), overriddenParams, context);
    }
  }

  send({
    url: href,
    httpMethod: form.method,
    data,
    scope,
    callback: onSuccess,
    context,
    __origin: form // metadata for use in onRequest
  });
}

//=============================================================================
function closest(el, predicate) {
  while (el.nodeType === Node.ELEMENT_NODE) {
    if (predicate(el)) return el;
    el = el.parentNode;
    if (!el) return el;
  }

  return null;
}

//=============================================================================
function closestAll(node, predicate) {
  while (true) {
    if (predicate(node)) return node;
    node = node.parentNode;
    if (!node) return node;
  }
}

//=============================================================================
let submitBtn = null; //

const isLink = el => el.tagName.toUpperCase() === "A" || prop(el, "role") === "a";

function clickListener (evt) {
  if (evt.defaultPrevented) return;
  if (evt.button !== 0) return;
  submitBtn = closest(evt.target, canSubmitForm);
  const link = closest(evt.target, isLink);
  if (link) {
    if (prop(link, "role") === "a") {
      handleClick(link);
      evt.preventDefault();
      return false;
    }

    // redirect link clicks wrt overridden params

    const overriddenParams = getOverriddenParams(link);
    if (overriddenParams) {
      evt.preventDefault();
      location.href = paramsToURL(link.href, mergeParams(paramsFromURL(link.href), overriddenParams, "global"));
      return false;
    }

    const retainedParams = getRetainedParams(link);
    if (retainedParams) {
      evt.preventDefault();
      const params = mergeParams(paramsFromURL(link.href), [], "global");
      location.href = paramsToURL(link.href, pickProps(params, retainedParams));
      return false;
    }
  }
}

$win
  .on("click", function ($evt) {
    const evt = $evt.originalEvent;
    if (evt) clickListener(evt);
  }).on("scroll", function () {
    spinnerCenterer.update();
  }).on("resize", function () {
    spinnerCenterer.update();
  });

window.addEventListener("submit", function (evt) {
  if (prop(evt.target, "role") === "form") {
    handleSubmit(evt.target, evt.submitter || submitBtn);
    evt.preventDefault();
  }
});
//=============================================================================
export var AJAX = {
  send: function (opts) {
    const jsonCallback = opts.callback;
    const jsonCallbackPre = opts.callbackPre;

    function onSuccess(response) {
      if (jsonCallbackPre) jsonCallbackPre();
      const ret = handleResponse(opts, response);
      if (jsonCallback) jsonCallback(ret);
      const location = opts.location === "url" ? opts.url : opts.location;
      if (location) {
        const context = opts.context || "global";
        setLocation(location, null, context);
        contexts[context].changedParams = paramsFromURL(location);
      }
    }

    opts = Object.assign({context: "global"}, opts, {callback: onSuccess});
    return send(opts);
  },
  setLocation: function (url, method, overriddenParams) {
    let params = paramsFromURL(url);
    if (overriddenParams) {
      params = mergeParams(params, overriddenParams, "global");
      url = paramsToURL(url, params);
    }
    setLocation(url, method, "global");
    contexts.global.changedParams = params;
  },
  onUpdate: function (cb) {
    callbacks_res.push(cb);
  },
  onRequest: function (cb) {
    callbacks_req.push(cb);
  },
  addIdCallback: function(id, cb) {
    if(typeof id !== "string") id = prop(id, "id");
    const callbacks = (callbacks_id[id] || (callbacks_id[id] = []));
    callbacks.push(cb);
  },
  handleClick,
  mergeParams: function(url, overriddenNames, context) {
    const params = paramsFromURL(url);
    return paramsToURL(url, mergeParams(params, overriddenNames, context || "global"));
  },
  handleSubmit,
  clickListener,
  getContext,
  serializeForm,
  setBodyClass: function(val) { setBodyClass = val; },
  spinnerCenterer
};
